var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-list-small"},[_c('ul',{staticClass:"feature-list-small__list"},_vm._l((_vm.filteredFeatures),function(feature){return _c('li',{key:feature.id,staticClass:"feature-list-small__list__item"},[_c('AppFeatureListItem',{attrs:{"text":feature.shortText,"icon":feature.icon,"small":""}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }